import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { IDocumentModel } from "./../interfaces/document-model";
import {prop} from "../../decorators/property";
import {DocumentCollection} from "../../desktop/collections/documents";
import {SiblingModel} from "../../desktop/models/stage";
import {CaseDocumentModel} from "../../desktop/models/case-document";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {transient} from "aurelia-dependency-injection";
import {TRANSITION} from "../../desktop/views/desktop";

@backboneModelProperties({
    relations : [{
        type: Backbone.Many,
        key: "Documents",
        relatedModel: AuthorizationModel,
        collectionType: DocumentCollection
    },
    {
        type: Backbone.Many,
        key: "Siblings",
        relatedModel: SiblingModel
    }
    ],
    defaults: {
        Populated: false,
        Visible: true,
        Refresh: true,
        Removed: false,
        Documents: [],
        Stages: []
    }
})
export class DocumentHolderModel extends Backbone.AssociatedModel {

        @prop() public Visible: boolean;
        @prop() public Refresh: boolean;
        @prop() public Removed: boolean;
        @prop() public Documents: DocumentCollection;
        /** Position relative to the screen of this DocumentHolder. Slots increase in number from left to right, the leftmost visible slot is 1. */
        @prop() public Slot: number;
        /** Id of one of the documents within this holder. Usually the Id of the most recent stage of judgement */
        @prop() public InitialStageId: string;
        @prop() public Compact: boolean;
        @prop() public Siblings: Backbone.Collection<SiblingModel>;
        /** The id of the "active" document within this holder */
        @prop() public Target: string;
        @prop() public Layer: number;
        @prop() public Outline: Backbone.Model;
        @prop() public ParentKey: string;
        @prop() public StackPosition: number;
        @prop() public PrecedentMap: any;

        constructor(options?) {
            super(options);
        }

        public addDocument(documentModel: IDocumentModel): void {
            this.Documents.add(documentModel);
            const id = documentModel.ParentId;
            this.Target = id;
        }

        public getDocumentById(id: string): IDocumentModel {
            let foundDocument = null;
            this.Documents.each((doc) => {
                if (doc.Id === id) {
                    foundDocument = doc;
                }
            });
            return foundDocument;
        }

        public getPotentialDocumentById(id: string): IDocumentModel {
            let foundDocument = null;
            if (this.Documents) {
                this.Documents.each((doc) => {
                    if (doc.Id === id) {
                        foundDocument = doc;
                    }
                });

                if (foundDocument === null && this.Siblings) {
                    this.Siblings.each((stage) => {
                        if (stage.Id === id ) {
                            foundDocument = stage;
                        }
                    });
                }
            }
            return foundDocument;
        }

        public hide(): void {
            this.Visible = false;
            this.refresh();
        }

        public show(): void {
            this.Visible = true;
            this.refresh();
        }

        /**
         * Sets the slot (position on the screen) of this document holder.
         * Slots start at 1, 1 being the leftmost document.
         */
        public setSlot(slot: number, transition: TRANSITION): void {
            this.Slot = slot;
            this.trigger("SlotChange", transition);
        }

        public clearTarget(): void {
            this.unset("Target");
        }

        public toggleCompact(): void {
            this.Compact = !this.Compact;
        }

        public expand(): void {
            this.Compact = false;
        }

        public contract(): void {
            this.Compact = true;
        }

        public get TargetModel(): IDocumentModel {
            const id = this.Target;
            return this.Documents.where({ ParentId: id })[0];
        }

        public set DocumentSize(width: number) {
            const documents = this.Documents;
            documents.each((doc) => {
                doc.FaceWidth = width;
            });
        }

        public unsetTarget(): void {
            this.unset("Target");
        }

        public remove(): void {
            this.Removed = true;
            this.unsetTarget();
            this.trigger("destroy", this);
        }

        public refresh(): void {
            this.Refresh = !this.Refresh;
        }

        public lockDocuments(): void {
            const documents = this.Documents;
            documents.each((doc) => {
                doc.Animated = false;
            });
        }

        public unlockDocuments(): void {
            const documents = this.Documents;
            documents.each((doc) => {
                doc.Animated = true;
            });
        }

        /** Marks all documents in the holder as populated false in this holder */
        public depopulateAllDocuments(): void {
            this.Documents.each((document) => {
                document.Populated = false;
            });
        }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/document-holder.ts